var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "reporting-settings-v2" },
        [
          _c("SavedReportForm", {
            staticClass: "m-b-10",
            attrs: {
              "saved-report": _vm.activeReport,
              "report-type": _vm.reportType,
              "is-admin": _vm.isAdmin
            },
            on: {
              onReportNameChange: _vm.onReportNameChange,
              onSave: _vm.saveReport,
              onUpdate: _vm.saveReport,
              onDelete: _vm.deleteReport,
              onSaveAs: _vm.duplicateReport
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "reporting-settings-v2__time" },
            [
              _c("TimeAgo", {
                staticClass: "m-r-10 m-b-10",
                attrs: {
                  "prefix-text": _vm.$t("UPDATED"),
                  "from-date": _vm.lastUpdated
                }
              }),
              _vm._v(" "),
              _vm.enableViewAs
                ? _c("SearchableDropdown", {
                    staticClass:
                      "reporting-settings-v2__timezone-selector m-b-10",
                    attrs: {
                      name: "V2ViewAsDropDown",
                      value: _vm.viewAs,
                      config: _vm.viewAsDropdownOptions,
                      rules: "required",
                      clearable: false
                    },
                    on: { input: _vm.setViewAs },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "option-data",
                          fn: function({ option }) {
                            return [
                              option.icon
                                ? _c("div", [
                                    _c("i", {
                                      staticClass:
                                        "view-as__option-heading typcn f-s-14",
                                      class: option.icon
                                    }),
                                    _c("span", {
                                      domProps: {
                                        textContent: _vm._s(option.name)
                                      }
                                    })
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              !option.icon
                                ? _c("div", {
                                    staticClass: "m-l-10",
                                    domProps: {
                                      textContent: _vm._s(option.name)
                                    }
                                  })
                                : _vm._e()
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1003947332
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("SearchableDropdown", {
                staticClass:
                  "reporting-settings-v2__timezone-selector m-b-10 m-l-10",
                attrs: {
                  rules: "required",
                  config: _vm.timezoneDropdownOptions,
                  clearable: false
                },
                model: {
                  value: _vm.tempTimezoneId,
                  callback: function($$v) {
                    _vm.tempTimezoneId = $$v
                  },
                  expression: "tempTimezoneId"
                }
              }),
              _vm._v(" "),
              _c("DateRangePicker", {
                staticClass: "m-b-10",
                attrs: {
                  "date-range-button-class":
                    "reporting-settings-v2__date-picker btn m-l-10",
                  "date-range": _vm.timeRange,
                  options: _vm.dateRangeConfig,
                  "time-zone-id": _vm.translatedTimeZoneId
                },
                on: { onDateRangeChange: _vm.onDateRangeChange }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("AutoReloadData", {
            staticClass: "reporting-settings-v2__auto-reload m-b-10 m-l-10",
            attrs: { "auto-reload-enabled": _vm.autoReloadEnabled },
            on: {
              toggleAutoReload: _vm.changeAutoReload,
              loadData: _vm.refreshData
            }
          }),
          _vm._v(" "),
          !_vm.hideTourButton
            ? _c(
                "button",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip.left",
                      value: _vm.$t("START_TOUR"),
                      expression: "$t('START_TOUR')",
                      modifiers: { left: true }
                    }
                  ],
                  staticClass: "btn m-l-10 m-b-10",
                  on: {
                    click: function($event) {
                      return _vm.$emit("onStartTour")
                    }
                  }
                },
                [_c("i", { staticClass: "fa fa-graduation-cap p-r-0" })]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("ReportingFilter", {
        attrs: {
          "filter-criteria": _vm.filterCriteria,
          "available-filters": _vm.availableFilters,
          "form-name-for-user-settings": _vm.formNameForUserSettings,
          "quick-filters": _vm.quickFilters
        },
        on: {
          applyFilters: _vm.onApplyFilters,
          clearFilters: _vm.onClearFilters
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }